export { default as FaqSection } from './FaqSection';
